import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Billing = () => {
  const [orders, setOrders] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [receipts, setReceipts] = useState([]);
  const [orderForm, setOrderForm] = useState({
    patientId: '',
    type: 'medication',
    items: [],
    totalAmount: 0,
  });
  const [invoiceForm, setInvoiceForm] = useState({
    patientId: '',
    orderId: '',
    amount: 0,
  });
  const [receiptForm, setReceiptForm] = useState({
    invoiceId: '',
    amount: 0,
    paymentMethod: 'cash',
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [ordersRes, invoicesRes, receiptsRes] = await Promise.all([
        axios.get(`${window.location.protocol}//${window.location.hostname}/api/orders/orders`),
        axios.get(`${window.location.protocol}//${window.location.hostname}/api/orders/invoices`),
        axios.get(`${window.location.protocol}//${window.location.hostname}/api/orders/receipts`),
      ]);
      setOrders(ordersRes.data);
      setInvoices(invoicesRes.data);
      setReceipts(receiptsRes.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleOrderSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${window.location.protocol}//${window.location.hostname}/api/orders/orders`, orderForm);
      setOrderForm({
        patientId: '',
        type: 'medication',
        items: [],
        totalAmount: 0,
      });
      fetchData();
    } catch (error) {
      console.error(error);
    }
  };

  const handleInvoiceSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${window.location.protocol}//${window.location.hostname}/api/orders/invoices`, invoiceForm);
      setInvoiceForm({
        patientId: '',
        orderId: '',
        amount: 0,
      });
      fetchData();
    } catch (error) {
      console.error(error);
    }
  };

  const handleReceiptSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${window.location.protocol}//${window.location.hostname}/api/orders/receipts`, receiptForm);
      setReceiptForm({
        invoiceId: '',
        amount: 0,
        paymentMethod: 'cash',
      });
      fetchData();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <h2>Billing</h2>
      <h3>Create Order</h3>
      <form onSubmit={handleOrderSubmit}>
        <input name="patientId" placeholder="Patient ID" value={orderForm.patientId} onChange={(e) => setOrderForm({ ...orderForm, patientId: e.target.value })} required />
        <select name="type" value={orderForm.type} onChange={(e) => setOrderForm({ ...orderForm, type: e.target.value })}>
          <option value="medication">Medication</option>
          <option value="test">Test</option>
          <option value="procedure">Procedure</option>
          <option value="service">Service</option>
        </select>
        <input name="totalAmount" type="number" placeholder="Total Amount" value={orderForm.totalAmount} onChange={(e) => setOrderForm({ ...orderForm, totalAmount: parseFloat(e.target.value) })} required />
        <button type="submit">Create Order</button>
      </form>
      <h3>Create Invoice</h3>
      <form onSubmit={handleInvoiceSubmit}>
        <input name="patientId" placeholder="Patient ID" value={invoiceForm.patientId} onChange={(e) => setInvoiceForm({ ...invoiceForm, patientId: e.target.value })} required />
        <input name="orderId" placeholder="Order ID" value={invoiceForm.orderId} onChange={(e) => setInvoiceForm({ ...invoiceForm, orderId: e.target.value })} />
        <input name="amount" type="number" placeholder="Amount" value={invoiceForm.amount} onChange={(e) => setInvoiceForm({ ...invoiceForm, amount: parseFloat(e.target.value) })} required />
        <button type="submit">Create Invoice</button>
      </form>
      <h3>Record Receipt</h3>
      <form onSubmit={handleReceiptSubmit}>
        <input name="invoiceId" placeholder="Invoice ID" value={receiptForm.invoiceId} onChange={(e) => setReceiptForm({ ...receiptForm, invoiceId: e.target.value })} required />
        <input name="amount" type="number" placeholder="Amount" value={receiptForm.amount} onChange={(e) => setReceiptForm({ ...receiptForm, amount: parseFloat(e.target.value) })} required />
        <select name="paymentMethod" value={receiptForm.paymentMethod} onChange={(e) => setReceiptForm({ ...receiptForm, paymentMethod: e.target.value })}>
          <option value="cash">Cash</option>
          <option value="card">Card</option>
          <option value="bank_transfer">Bank Transfer</option>
          <option value="insurance">Insurance</option>
        </select>
        <button type="submit">Record Receipt</button>
      </form>
      <h3>Orders</h3>
      <ul>
        {orders.map(order => (
          <li key={order.id}>Order {order.id} for Patient {order.patientId} - ${order.totalAmount}</li>
        ))}
      </ul>
      <h3>Invoices</h3>
      <ul>
        {invoices.map(invoice => (
          <li key={invoice.id}>Invoice {invoice.id} for Patient {invoice.patientId} - ${invoice.amount} - Balance: ${invoice.balance}</li>
        ))}
      </ul>
    </div>
  );
};

export default Billing;